import { CustomerGroupMessage } from '../../../../../types/CustomerGroupMessage';
import { Link } from '../../../../cdl/Link/Link';
import { Text } from '../../../../cdl/Text/Text';
import { BooleanStatus } from '../../../../common/BooleanStatus/BooleanStatus';
import { DataSheet } from '../../../../common/DataSheet/DataSheet';
import { formatAddress } from '../../../../common/helpers/formatAddress.helper';
import { translate } from '../../../../common/helpers/translate.helper';
import { Characters } from '../../../../common/helpers/unicode.helper';
import { Box } from '../../../../common/ui/Box';

interface CustomerGroupDataSheetProps {
    customerGroup: CustomerGroupMessage;
}

export const CustomerGroupDataSheet = ({ customerGroup }: CustomerGroupDataSheetProps) => {
    return (
        <Box display="grid" gridTemplateColumns="1fr 1fr" gap={40}>
            <DataSheet>
                <DataSheet.Label>{translate('global.contact.name')}</DataSheet.Label>
                <Text variant="small">{customerGroup.name || Characters.EN_DASH}</Text>

                <DataSheet.Label>{translate('global.email')}</DataSheet.Label>
                <Text variant="small">{customerGroup.email || Characters.EN_DASH}</Text>

                <DataSheet.Label>{translate('global.contact.phone')}</DataSheet.Label>
                <Text variant="small">{customerGroup.phone || Characters.EN_DASH}</Text>

                <DataSheet.Label>{translate('global.contact.fax')}</DataSheet.Label>
                <Text variant="small">{customerGroup.fax || Characters.EN_DASH}</Text>
            </DataSheet>
            <DataSheet>
                <DataSheet.Label>{translate('company.gtc')}</DataSheet.Label>
                <Link external href={customerGroup.gtcUrl} target="_blank" size="small">
                    {translate('company.gtcView')}
                </Link>
                <DataSheet.Label>{translate('company.gtcAccepted')}</DataSheet.Label>
                <BooleanStatus
                    value={customerGroup.gtcAccepted}
                    label={
                        customerGroup.gtcAccepted
                            ? translate('company.gtcStatusAccepted')
                            : translate('company.gtcNotAccepted')
                    }
                />

                <DataSheet.Label>{translate('global.address.title')}</DataSheet.Label>
                <Text variant="small">
                    {customerGroup.address ? formatAddress({ address: customerGroup.address }) : Characters.EN_DASH}
                </Text>
            </DataSheet>
        </Box>
    );
};
